<script setup lang="ts">
import FileVaultUploadModal from '@/components/file_vault/FileVaultUploadModal.vue';
import type { UploadedVaultRevision } from '@/composables/useVaultUpload';
import { useVaultUploadDialogHost } from '@/composables/useVaultUploadDialog';

/**
 * The app-wide "upload to…" dialog behind `useVaultUploadDialog()`. Mounted
 * once in App.vue so handlers (drops, quick actions, chat) can await a
 * destination and the uploaded files without each owning a modal.
 */
const { request, settle } = useVaultUploadDialogHost();

// Set by `uploaded-files`, which fires just before the dialog closes itself.
let landed: UploadedVaultRevision[] | null = null;

function handleUploadedFiles(files: UploadedVaultRevision[]): void {
  landed = files;
}

function handleShow(show: boolean): void {
  if (show) return;
  const files = landed;
  landed = null;
  settle(files);
}
</script>

<template>
  <file-vault-upload-modal
    :show="request !== null"
    selectable-destination
    :scope-root-uid="request?.scopeRootUid"
    :scope-root-label="request?.scopeRootLabel"
    :initial-files="request?.files"
    :accept="request?.accept"
    :max="request?.max"
    :unpack-archives="false"
    @uploaded-files="handleUploadedFiles"
    @update:show="handleShow"
  />
</template>
